import React from 'react';
import { CustomHyperlink } from './CustomHyperlink';
import '../UserAuthStateForm.scss';
export const AuthLinkComponent = ({ link = '', text = '', descp = '', styleClass = '', }) => (React.createElement(React.Fragment, null, link && (React.createElement(CustomHyperlink, { link: link, text: text, descp: descp, styleClass: styleClass }))));
//# sourceMappingURL=AuthLinkComponent.js.map